export default {
  buttonVariant: 'primary',
};
